import comp from "./TagSnp";
export default comp;
